import React from 'react'
import styled from 'styled-components'
import {IMAGE_ASSET, WINDOW_MODE_TABLET_WIDTH} from 'consts'
import {useTranslation} from 'i18n'
import {useHistory} from 'utils'
import convertUnit from 'lib/unit'
import {Button, Image, Paragraph} from 'common/components'

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-self: center;
  background-color: ${({theme}) => theme.white_3};
`
const StyledContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: ${convertUnit(16)};
  text-align: center;
  max-width: ${convertUnit(560)};
  margin-top: ${convertUnit(20)};
  padding: 0 ${convertUnit(20)};
  height: fit-content;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    min-width: 100%;
    width: fill-available;
    height: 100%;
    border-radius: 0;
    margin-top: 0;
  }
  background-color: ${({theme}) => theme.white_1};
`
const StyledBodyContainer = styled.div`
  overflow-y: scroll;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    max-width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 0 ${convertUnit(20)};
  }
`
const StyledTitle = styled(Paragraph)`
  margin: ${convertUnit(16)} 0 ${convertUnit(12)} 0;
`
const StyledFooter = styled.div`
  margin-bottom: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(4)};
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    max-width: 100%;
    border-radius: 0;
    padding: 0 ${convertUnit(20)};
  }
`

export default function GiftShopSettingAuthenticatorSetupSuccess() {
  const {translate} = useTranslation()
  const history = useHistory()

  return (
    <StyledContainer>
      <StyledContentContainer>
        <StyledBodyContainer>
          <StyledTitle fontSize="xl" fontWeight="bold">
            {translate('giftShop:settingAuthAppEnabledTitle')}
          </StyledTitle>
          <Paragraph fontSize="m" color="gray_5">
            {translate('giftShop:settingAuthAppEnabledDesc')}
          </Paragraph>
          <div>
            <Image
              src={IMAGE_ASSET('giftshop', 'authenticator-success.png')}
              alt=""
            />
          </div>
        </StyledBodyContainer>
        <StyledFooter>
          <Button
            label={translate('global:done')}
            onClick={() => history.goBack()}
          />
        </StyledFooter>
      </StyledContentContainer>
    </StyledContainer>
  )
}
